import { registerPlugin } from '@capacitor/core';

export interface NativeDownloadsPlugin {
  saveFile(options: {
    base64Data: string;
    filename: string;
    mimeType?: string;
  }): Promise<{
    filename: string;
    mimeType: string;
    byteCount: number;
    uri: string;
    location: string;
  }>;
  startSave(options: {
    filename: string;
    mimeType?: string;
  }): Promise<{
    saveId: string;
    filename: string;
    mimeType: string;
    byteCount: number;
    uri: string;
    location: string;
  }>;
  appendChunk(options: {
    saveId: string;
    base64Data: string;
  }): Promise<{
    saveId: string;
    byteCount: number;
  }>;
  finishSave(options: {
    saveId: string;
  }): Promise<{
    filename: string;
    mimeType: string;
    byteCount: number;
    uri: string;
    location: string;
  }>;
  cancelSave(options: {
    saveId: string;
  }): Promise<{
    saveId: string;
  }>;
}

export const NativeDownloads = registerPlugin<NativeDownloadsPlugin>('NativeDownloads');
